// removed by extract-text-webpack-plugin
module.exports = {"fixed-footer":"_3nhFE","fixed-share-button":"wk0tk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageFooter.scss
// module id = ./src/components/Page/PageFooter.scss
// module chunks = 5